import { askChatGPT, getGeneratedImage } from "./openai";
import { createCompany, deleteCompany as deleteCompanyRecord, updateCompany as updateCompanyRecord } from "../../graphql/operations";

export const postCompany = (companyData) => createCompany(companyData);

export const updateCompany = (id, data) => updateCompanyRecord(id, data);

export const fetchNewLogo = async (company, shouldUpdate) => {
  const logoDescription = await askChatGPT(`${company.prompt}. Simple description of a possible profile pic idea for ${company.name}. No text or font | [Image description]`);
  const logo = await getGeneratedImage("512x512", `${logoDescription}, centered`);

  if (shouldUpdate) {
    await updateCompany(company._id, { logo });
  }

  return logo;
};

export const fetchNewName = async (prompt, company, shouldUpdate, exclusions) => {
  const idea = prompt || company?.prompt || company?.description || "";
  const avoided = exclusions?.length ? ` Do not use any of these names: ${exclusions.join(", ")}.` : "";
  const nameRaw = await askChatGPT(`Business idea: ${idea}.${avoided} Choose exactly one company name for this single business. Reply with only that name. Do not list options, alternatives, or explanations.`, 1, 8);
  const name = nameRaw.split(":").join("").split("\"").join("").trim();

  // Make a new slug to go with the new name
  const slugRaw = await askChatGPT(`Company name: ${name}. Idea: ${idea}. Reply with only a short url slug for this company: one lowercase word, or hyphenated words. No spaces, labels, or explanation.`, 1, 8);
  const slug = slugRaw.split("\n").join("").split("").filter((c) => {
    return (c >= "0" && c <= "9") || (c >= "a" && c <= "z") || (c >= "A" && c <= "Z") || c === "-"
  }).join("").trim();

  if (!name.length) throw new Error('empty name');

  if (shouldUpdate) {
    await updateCompany(company?._id, { name, slug });
  }

  return name;
};

export const fetchNewTagline = async (company, shouldUpdate, exclusions) => {
  const avoided = exclusions?.length ? ` Do not use any of these taglines: ${exclusions.join(", ")}.` : "";
  const taglineRaw = await askChatGPT(`Company name: ${company.name}. About the company: ${company.description}.${avoided} Write exactly one short tagline, a single phrase of no more than 8 words. Reply with only that phrase. Do not use a table, columns, labels, quotes, or a list of options.`, 1, 24);
  const tagline = taglineRaw.split("\"").join("");

  if (!tagline.length) throw new Error('empty tagline');

  if (shouldUpdate) {
    await updateCompany(company?._id, { tagline });
  }

  return tagline;
};

export const deleteCompany = (companyId) => deleteCompanyRecord(companyId);